<template>
  <div class="search-detail">
    <Aheader :realIndex="1"></Aheader>
    <div class="banner">
      <p>
        <span style="font-style: italic;">{{ species.italicName }}</span
        ><span>{{ species.notItalicName }}</span>
      </p>
    </div>
    <div class="content">
      <p class="path">
        <router-link to="/home">Home Page</router-link>
        <span v-if="this.$route.query.input !== undefined" style="color:#999">
          /
        </span>
        <a v-if="this.$route.query.input !== undefined" @click="backSearch"
          >Search Result</a
        >
        <span style="color:#999"> / </span>
        <span> Details </span>
      </p>
      <div class="common base-mes">
        <div class="img-box">
          <img
            :src="species.imgCode || baseImg"
            :class="{ imgFull: species.imgCode }"
            alt=""
          />
          <p v-if="!species.imgCode" style="cursor: default;">No picture</p>
        </div>
        <div class="base-list">
          <p class="list-title">NCBI taxonomy</p>
          <table cellpadding="0" border="0" cellspacing="0">
            <tr>
              <!-- 界 -->
              <td>Kingdom</td>
              <td>
                <span>{{ species.kingdom || '-' }} </span>
              </td>
            </tr>
            <tr>
              <!-- 门 -->
              <td>Phylum</td>
              <td style="font-style: italic;">
                {{ species.phylum || '-' }}
              </td>
            </tr>
            <tr>
              <!-- 钢 -->
              <td>Class</td>
              <td style="font-style: italic;">{{ species.outline || '-' }}</td>
            </tr>
            <tr>
              <!-- 目 -->
              <td>Order</td>
              <td style="font-style: italic;">
                {{ species.catalogue || '-' }}
              </td>
            </tr>
            <tr>
              <!-- 科 -->
              <td>Family</td>
              <td style="font-style: italic;">{{ species.family || '-' }}</td>
            </tr>
            <tr>
              <!-- 属 -->
              <td>Genus</td>
              <td style="font-style: italic;">
                {{ species.genusName || '-' }}
              </td>
            </tr>
            <!-- 物种 -->
            <tr>
              <td>Species</td>
              <td>
                <span style="font-style: italic;">{{ species.italicName }}</span
                ><span>{{ species.notItalicName }}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="common name-mes">
        <div style="margin-top: 0;">
          <p>Algae Name：</p>
          <p class="name-margin name-width">
            <span
              :class="{ nameJump: species.match }"
              @click="toAnnotation(species.match, species.speciesName)"
            >
              <span style="font-style: italic;">{{ species.italicName }}</span
              ><span>{{ species.notItalicName }}</span></span
            >
            <span v-if="species.synonymousName" style="font-style: italic;"
              >（{{ species.synonymousName }}）</span
            >
          </p>
        </div>
        <div class="name-mes-top">
          <div>
            <p>FWAlgaeDB ID：</p>
            <p class="name-margin">{{ species.databaseCode || '-' }}</p>
          </div>
          <div>
            <p>NCBI Taxonomy ID：</p>
            <p class="name-margin">{{ species.speciesCode || '-' }}</p>
          </div>
        </div>
        <!-- <div>
          <p>Synonymous name：</p>
          <p class="name-margin" style="width:900px;font-style: italic;">
            {{ species.synonymousName || '-' }}
          </p>
        </div> -->
        <div>
          <p>Living Environment：</p>
          <p class="environment-width">{{ species.environment || '-' }}</p>
        </div>
        <div>
          <p>Geographic Location：</p>
          <p class="environment-width">{{ species.geographicLocation || '-' }}</p>
        </div>
      </div>
      <div class="common download">
        <div class="down-box">
          <p>Genome Sequence Download</p>
          <div
            v-if="genomeSequenceList.length == 0"
            class="no-data"
            style="color:#999"
          >
            No data
          </div>
          <div v-else>
            <div
              class="down-list"
              v-for="item in genomeSequenceList"
              :key="item.index"
              v-loading="loading"
              element-loading-text="Data downloading"
              element-loading-spinner="el-icon-loading"
            >
              <div>
                <div class="svg-box">
                  <svg
                    @click="downFile(item)"
                    t="1645080817736"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="3799"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M224 422.4l230.4 224c12.8 12.8 38.4 25.6 57.6 25.6 19.2 0 44.8-6.4 57.6-25.6l230.4-224c19.2-19.2 19.2-44.8 0-64-6.4-6.4-19.2-12.8-32-12.8s-25.6 6.4-32 12.8L556.8 537.6V44.8C556.8 19.2 537.6 0 512 0c-25.6 0-44.8 19.2-44.8 44.8v486.4L288 358.4c-12.8-6.4-19.2-12.8-32-12.8s-25.6 6.4-32 12.8c-12.8 12.8-19.2 19.2-19.2 32s6.4 25.6 19.2 32z m0 0"
                      fill="#999999"
                      p-id="3800"
                    ></path>
                    <path
                      d="M838.4 121.6c-25.6 0-44.8 19.2-44.8 44.8 0 25.6 19.2 44.8 44.8 44.8 51.2 0 96 44.8 96 96V832c0 51.2-44.8 96-96 96H185.6c-51.2 0-96-44.8-96-96V307.2c0-51.2 44.8-96 96-96 25.6 0 44.8-19.2 44.8-44.8 0-25.6-19.2-44.8-44.8-44.8C83.2 121.6 0 204.8 0 307.2V832c0 102.4 83.2 192 185.6 192h652.8c102.4 0 185.6-83.2 185.6-192V307.2c0-102.4-83.2-185.6-185.6-185.6z m0 0"
                      fill="#999999"
                      p-id="3801"
                    ></path>
                  </svg>
                </div>
                <img src="../../assets/img/down-file.svg" alt="" />
                <p>{{ item.sfName }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="down-box">
          <p>Downloading microscopic examination results</p>
          <div v-if="microscopyResultsList.length == 0" class="no-data" style="color:#999">
            No data
          </div>
          <div v-else>
            <div
              class="down-list"
              v-for="item in microscopyResultsList"
              :key="item.index"
            >
              <div>
                <div class="svg-box">
                  <svg
                    @click="downFile(item)"
                    t="1645080817736"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="3799"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M224 422.4l230.4 224c12.8 12.8 38.4 25.6 57.6 25.6 19.2 0 44.8-6.4 57.6-25.6l230.4-224c19.2-19.2 19.2-44.8 0-64-6.4-6.4-19.2-12.8-32-12.8s-25.6 6.4-32 12.8L556.8 537.6V44.8C556.8 19.2 537.6 0 512 0c-25.6 0-44.8 19.2-44.8 44.8v486.4L288 358.4c-12.8-6.4-19.2-12.8-32-12.8s-25.6 6.4-32 12.8c-12.8 12.8-19.2 19.2-19.2 32s6.4 25.6 19.2 32z m0 0"
                      fill="#999999"
                      p-id="3800"
                    ></path>
                    <path
                      d="M838.4 121.6c-25.6 0-44.8 19.2-44.8 44.8 0 25.6 19.2 44.8 44.8 44.8 51.2 0 96 44.8 96 96V832c0 51.2-44.8 96-96 96H185.6c-51.2 0-96-44.8-96-96V307.2c0-51.2 44.8-96 96-96 25.6 0 44.8-19.2 44.8-44.8 0-25.6-19.2-44.8-44.8-44.8C83.2 121.6 0 204.8 0 307.2V832c0 102.4 83.2 192 185.6 192h652.8c102.4 0 185.6-83.2 185.6-192V307.2c0-102.4-83.2-185.6-185.6-185.6z m0 0"
                      fill="#999999"
                      p-id="3801"
                    ></path>
                  </svg>
                </div>
                <img src="../../assets/img/down-file.svg" alt="" />
                <p>{{ item.sfName }}</p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="common reference">
        <p>References</p>
        <p
          v-if="literatureList.length == 0"
          style="margin-top: 25px;color:#999;"
        >
          No literature
        </p>
        <p
          v-else
          class="ref-detail"
          v-for="(item, index) in literatureList"
          :key="item.index"
        >
          <span style="margin-right:5px">[{{ index + 1 }}]</span>
          <span>{{ item.literatureName }} </span>
        </p>
      </div>
      <div class="common tips">NOTE：If involves copyright disputes, please contact us to delete.</div>
    </div>
    <Afooter></Afooter>
  </div>
</template>

<script>
import http from '../../utils/http'
import api from '../../utils/api'
import { Message } from 'element-ui'
import Aheader from '../../components/aheader.vue'
import Afooter from '../../components/afooter.vue'
import Img from '../../assets/img/search-base1.png'

export default {
  name: 'HomeDetail',
  components: {
    Aheader,
    Afooter
  },
  data () {
    return {
      species: [],
      genomeSequenceList: [],
      // microscopyResultsList: [],
      literatureList: [],
      baseImg: Img,
      activeName: 'first',
      loading: false
    }
  },
  created () {
    this.$store.commit('toTop')
    // 获取数据
    http.get(`/speciesListById?id=${this.$route.query.id}`, {}, res => {
      if (res.code === 200) {
        this.species = res.data.species
        let obj = this.$utils.getItalic(this.species.speciesName)
        this.species.italicName = obj.italicName
        this.species.notItalicName = obj.notItalicName
        this.genomeSequenceList = res.data.genomeSequenceList
        // this.microscopyResultsList = res.data.microscopyResultsList
        // let str = 'Image source (copyright): ' + res.data.literatureList[res.data.literatureList.length - 1]['literatureName']
        // res.data.literatureList[res.data.literatureList.length - 1]['literatureName'] = str
        this.literatureList = res.data.literatureList
      } else {
        Message.error(`${res.msg}`)
      }
    })
  },
  methods: {
    // 跳到annotation
    toAnnotation (match, speciesName) {
      if (match) {
        this.$router.push({
          name: 'Annotation',
          params: { speciesName: speciesName }
        })
      }
    },
    // 返回搜索页面
    backSearch () {
      this.$router.push(`/home/search?input=${this.$route.query.input}`)
    },
    // 切换标签页
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    // 下载文件
    async downFile (item) {
      let res = await api.getSetCheckLogin()
      if (res === '' || (res.data && res.data.code === 200)) {
        this.loading = true
        api.queryFileInfoById(item.fileId).then(res => {
          if (res.data.code === 200) {
            if (res.data.data) {
              // let element = document.createElement('a')
              // element.setAttribute('href', `/storage/getFileOutputStreamById?fileId=${item.fileId}`)
              // element.setAttribute('download', item.sfName)
              // element.style.display = 'none'
              // element.click()
              window.location.href = `/storage/getFileOutputStreamById?fileId=${item.fileId}`
            } else {
              Message.error('File not found')
            }
          } else {
            Message.error(`${res.msg}`)
          }
          this.loading = false
        })
      } else {
        Message.error('not logged in')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-detail {
  box-sizing: border-box;
  min-width: vw(1200);
}
.banner {
  margin-top: vw(81);
  min-width: vw(1200);
  height: vw(356);
  background-image: url('../../assets/img/home-detail-banner.png');
  background-size: 100% 100%;
  padding-top: vw(130);
  box-sizing: border-box;
  p {
    width: vw(1200);
    margin: 0 auto;
    font-size: vw(42);
    color: #ffffff;
  }
}
.content {
  width: vw(1200);
  margin: 0 auto;
  box-sizing: border-box;
  padding-top: vw(25);
  .path {
    color: #333;
    font-size: vw(16);
    margin-bottom: vw(52);
    a {
      color: #999;
      cursor: pointer;
      &:hover {
        color: $theme_color;
      }
    }
  }
  .common {
    width: vw(1200);
    box-shadow: 0px 0px 4px 0px rgba(65, 65, 65, 0.05);
    background: #ffffff;
    border-radius: 4px;
    margin-bottom: vw(24);
    font-size: vw(16);
    color: #333;
    box-sizing: border-box;
    border: 1px solid rgba(65, 65, 65, 0.05);
    padding: vw(25);

    .no-data {
      margin-top: 50px;
    }
  }
  .base-mes {
    display: flex;
    .img-box {
      margin-top: vw(25);
      background-color: rgb(202, 204, 206);
      width: vw(423);
      height: vw(289);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #999999;
      font-size: vw(14);
      margin-right: vw(50);
      border-radius: 4px;
      > p {
        margin-top: 20px;
        font-size: 20px;
        color: #fff;
      }
      .imgFull {
        width: 100%;
        height: 100%;
      }
    }
    .base-list {
      .list-title {
        margin-bottom: vw(22);
      }
      table {
        text-align: left;
        tr {
          height: vw(34);
          &:nth-child(2n) {
            background-color: #fff;
          }
          &:nth-child(2n + 1) {
            background-color: #f8f8f8;
          }
          td {
            width: vw(380);
            padding: vw(10) vw(40) vw(10) vw(14);
            overflow: hidden;
            &:first-child {
              width: vw(120);
            }
            &:last-child {
              padding-right: vw(20);
            }
          }
        }
      }
    }
  }
  .name-mes {
    > div {
      display: flex;
      align-items: flex-start;
      // flex-wrap: wrap;
      margin-top: vw(10);
    }
    .name-mes-top {
      // margin-top: 0;
      > div {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        &:first-child {
          margin-right: 180px;
        }
      }
    }

    .nameJump {
      cursor: pointer;
      color: $theme_color_hover;
      &:hover {
        text-decoration: underline;
      }
    }

    // p {
    //   display: flex;
    //   align-items: flex-start;
    //   flex-wrap: wrap;
    //   &:last-child {
    //     margin-top: vw(10);
    //     line-height: 1.5;
    //   }
    // }
    // .name-margin {
    //   // display: inline-block;
    //   width: 140px;
    // }
  }
  .name-width {
    width: vw(900);
    word-break: break-all;
  }
  .environment-width {
    width: vw(800);
    word-break: break-all;
  }
  .download {
    display: flex;

    position: relative;
    // &::after {
    //   content: '';
    //   position: absolute;
    //   top: 18%;
    //   left: 50%;
    //   transform: translateX(-50%);
    //   height: 70%;
    //   width: 2px;
    //   background: #dddddd7a;
    // }
    .down-title {
      cursor: pointer;
      margin-bottom: vw(13);
    }
    .down-box {
      // height: vw(200);
      .down-list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: vw(9) 0 0;
        text-align: center;
        > div {
          box-sizing: border-box;
          width: vw(160);
          // height: vw(165);
          position: relative;
          padding: 5px;
          box-sizing: border-box;
          border-radius: 4px;
          img {
            width: vw(80);
            height: vw(91);
            margin-top: vw(22);
          }
          p {
            width: 90%;
            margin-left: 5%;
            word-break: break-all;
          }
          .svg-box {
            svg {
              position: absolute;
              margin-right: vw(13);
              cursor: pointer;
              top: vw(10);
              right: 0;
            }
            &:hover {
              svg path {
                fill: $theme_color;
              }
            }
          }
          &:hover {
            background: #f8f8f8;
          }
        }
      }
      &:first-child {
        margin-right: 380px;
      }
    }
  }
  .reference {
    padding-top: vw(23);
    padding-bottom: vw(23);

    .ref-detail {
      display: flex;
      margin-top: vw(10);
      color: #666666;
      font-size: vw(14);
    }
  }
  .tips{
    margin-bottom: vw(260);
    color: #999;
    font-size: vw(14);
    font-style: italic;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/homeDetail.vue